module.exports = __webpack_public_path__ + "img/ceyiceTwo.8577ea8e.png";